// extracted by mini-css-extract-plugin
module.exports = {"link":"Link_link__N_GWc text_text-1__3dFwF","navigational":"Link_navigational__2ivjP","selected":"Link_selected__2-Sz9"};